export default __webpack_public_path__ + "static/media/1785.7789048b.png";